module.exports = __webpack_public_path__ + "static/university-dd6a2091487a644563033ec84ca2cb3e.jpg";